// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gapsybdmupload-page .upload-area {
  border: 2px dashed #0d6efd;
  text-align: center;
  /* background: #f8f9fa; */
  cursor: pointer;
  transition: all 0.3s ease;
}

.gapsybdmupload-page .upload-area:hover {
  border-color: #0d6efd;
  /* background: #e7f3ff; */
}

.gapsybdmupload-page .upload-area.dragover {
  border-color: #0d6efd;
  /* background: #e7f3ff; */
  transform: scale(1.02);
}

.gapsybdmupload-page .upload-area .bi-cloud-upload {
  background: blue;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: float 3s ease-in-out infinite;
}

.gapsybdmupload-page .verticaline-border-1 {
  border-left: 2px solid #dee2e6;
  height: 400px; /* or dynamic if needed */
}

.custom-dropdown-sheet {
  position: relative;
  display: inline-block;
}
.custom-dropdown:hover .custom-dropdown-menu {
  display: block;
  opacity: 1;
  transform: translateY(-5px);
}


/* Dropdown Menu */
.custom-dropdown-menu-sheet {
  display: none;
  position: absolute;
  left: 83px;
  background-color: white;
  top: 5px;
  border-radius: 6px;
  min-width: 200px;
  max-height: calc(5 * 22px); 
  overflow-y: auto; 
  border: 1px solid #ccc;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  padding: 4px 0;
  list-style: none;
  z-index: 1000;
  transition: all 0.3s ease-in-out;
}

/* Show dropdown on hover */
.custom-dropdown-sheet:hover .custom-dropdown-menu-sheet {
  display: block;
  opacity: 1;
  transform: translateY(-5px);
}


.custom-dropdown-menu-sheet::-webkit-scrollbar {
  width: 6px;
}

.custom-dropdown-menu-sheet::-webkit-scrollbar-thumb {
  /* background-color: #26b7ec; */
  border-radius: 4px;
}

.custom-dropdown-menu-sheet::-webkit-scrollbar-track {
  background: #f1f1f1;
}

 .custom-dropdown-menu {

  opacity: 1;
  transform: translateY(0);
  transition: all 0.3s ease-in-out;
} 

`, "",{"version":3,"sources":["webpack://./src/assets/css/gapsybdmupload.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,aAAa,EAAE,yBAAyB;AAC1C;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,UAAU;EACV,2BAA2B;AAC7B;;;AAGA,kBAAkB;AAClB;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,gCAAgC;AAClC;;AAEA,2BAA2B;AAC3B;EACE,cAAc;EACd,UAAU;EACV,2BAA2B;AAC7B;;;AAGA;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;CAEC;;EAEC,UAAU;EACV,wBAAwB;EACxB,gCAAgC;AAClC","sourcesContent":[".gapsybdmupload-page .upload-area {\r\n  border: 2px dashed #0d6efd;\r\n  text-align: center;\r\n  /* background: #f8f9fa; */\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.gapsybdmupload-page .upload-area:hover {\r\n  border-color: #0d6efd;\r\n  /* background: #e7f3ff; */\r\n}\r\n\r\n.gapsybdmupload-page .upload-area.dragover {\r\n  border-color: #0d6efd;\r\n  /* background: #e7f3ff; */\r\n  transform: scale(1.02);\r\n}\r\n\r\n.gapsybdmupload-page .upload-area .bi-cloud-upload {\r\n  background: blue;\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n  animation: float 3s ease-in-out infinite;\r\n}\r\n\r\n.gapsybdmupload-page .verticaline-border-1 {\r\n  border-left: 2px solid #dee2e6;\r\n  height: 400px; /* or dynamic if needed */\r\n}\r\n\r\n.custom-dropdown-sheet {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n.custom-dropdown:hover .custom-dropdown-menu {\r\n  display: block;\r\n  opacity: 1;\r\n  transform: translateY(-5px);\r\n}\r\n\r\n\r\n/* Dropdown Menu */\r\n.custom-dropdown-menu-sheet {\r\n  display: none;\r\n  position: absolute;\r\n  left: 83px;\r\n  background-color: white;\r\n  top: 5px;\r\n  border-radius: 6px;\r\n  min-width: 200px;\r\n  max-height: calc(5 * 22px); \r\n  overflow-y: auto; \r\n  border: 1px solid #ccc;\r\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n  padding: 4px 0;\r\n  list-style: none;\r\n  z-index: 1000;\r\n  transition: all 0.3s ease-in-out;\r\n}\r\n\r\n/* Show dropdown on hover */\r\n.custom-dropdown-sheet:hover .custom-dropdown-menu-sheet {\r\n  display: block;\r\n  opacity: 1;\r\n  transform: translateY(-5px);\r\n}\r\n\r\n\r\n.custom-dropdown-menu-sheet::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.custom-dropdown-menu-sheet::-webkit-scrollbar-thumb {\r\n  /* background-color: #26b7ec; */\r\n  border-radius: 4px;\r\n}\r\n\r\n.custom-dropdown-menu-sheet::-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n}\r\n\r\n .custom-dropdown-menu {\r\n\r\n  opacity: 1;\r\n  transform: translateY(0);\r\n  transition: all 0.3s ease-in-out;\r\n} \r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
